import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';

import { RequestStatus } from '@/pages/avatar/common';
import { useCreateAvatarStore } from '@/pages/avatar/common/context';

import { AvatarConsent } from './AvatarConsent';
import { ConsentError } from './ConsentError';

const ConsentStepContainer = styled.div`
    display: flex;
    align-items: center;
    padding: 32px 0 40px;
    width: 560px;
    margin: 0 auto;
`;

export const FullConsent = observer(() => {
    const createAvatarStore = useCreateAvatarStore();

    return (
        <ConsentStepContainer>
            {createAvatarStore.consentValidationStatus === RequestStatus.ERROR ? <ConsentError /> : <AvatarConsent />}
        </ConsentStepContainer>
    );
});
